import React from 'react';
import GroupingForm from './GroupingsForm';
import { useDeleteUnitTypeGrouping } from '~/groupings';
import { Table, Button } from 'semantic-ui-react';


import {

    Dialog,
    DialogContent
} from '@material-ui/core';


const GroupingTable = props => {

    const { data } = props;

    const { mutate: deleteGrouping } = useDeleteUnitTypeGrouping();
    const [open, setOpen] = React.useState(false);
    const [initialValues, setInitialValues] = React.useState(null);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <div>
            <Table columns={2} fixed size='small'>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell> Name </Table.HeaderCell>
                        <Table.HeaderCell textAlign='right'> Actions </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {(data.groupings || []).map(grouping => (
                        <Table.Row key={grouping.id}>
                            <Table.Cell content={grouping.name}/>

                            <Table.Cell textAlign='right'>
                                <Button.Group>
                                    <Button
                                        compact
                                        content='Edit'
                                        icon='edit'
                                        onClick={() => {
                                            setInitialValues(grouping);
                                            handleOpen();
                                        }}
                                    />
                                    <Button
                                        compact
                                        negative
                                        content='Delete'
                                        icon='delete'
                                        onClick={() => deleteGrouping(grouping.id)}
                                    />
                                </Button.Group>
                            </Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
                <Table.Footer>
                    <Table.Row>
                        <Table.HeaderCell colSpan='2' textAlign='right'>
                            <Button
                                compact
                                primary
                                content='New Grouping'
                                onClick={() => {
                                    setInitialValues({ property_id: data.id });
                                    handleOpen();
                                }}/>
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Footer>
            </Table>
            <Dialog fullWidth maxWidth='sm' open={open} onClose={handleClose}>
                <DialogContent>
                    <GroupingForm data={data} handleClose={handleClose} initialValues={initialValues}/>
                </DialogContent>
            </Dialog>

        </div>
    );


};

export default GroupingTable;
